import { useMutation } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import { AccountOperationsViewModel } from '../../../viewmodels/AdminViewModels';
import { InternalMeetingNoteType, ICustomerMeeting } from '../../../models/AdminModels';
import { CsmMeetingTypes, IAccount, RichContentContextSource } from '../../../extViewmodels';
import { convertTextToHtml, wrapInDocumentTags } from './textToHtmlUtils';

export interface IAddMeetingNoteRequest {
	account: IAccount;
	meetingType: CsmMeetingTypes;
	meetingStatus: string;
	durationInMinutes: number;
	meetingTags?: string[];
	noteContent: string;
}

export function useAdminAccountMeetingNoteMutation() {
	const userSession = useAdminUserSession();

	return useMutation({
		mutationFn: async (request: IAddMeetingNoteRequest) => {
			const accountOperations = new AccountOperationsViewModel(userSession, request.account);

			// Convert plain text to HTML wrapped in lev-content tags
			const htmlContent = convertTextToHtml(request.noteContent);
			const documentContent = wrapInDocumentTags(htmlContent);

			// Create the meeting request payload with IRawRichTextContentState format
			const meetingRequest: ICustomerMeeting = {
				durationInMinutes: request.durationInMinutes,
				meetingStatus: request.meetingStatus,
				meetingTags: request.meetingTags || [],
				meetingType: request.meetingType,
				metWith: InternalMeetingNoteType.CSM,
				note: {
					content: {
						document: documentContent,
						documentVersion: 1,
					},
					context: {
						source: RichContentContextSource.Meeting,
						meetingType: request.meetingType,
						meetingStatus: request.meetingStatus,
						durationInMinutes: request.durationInMinutes,
						meetingTags: request.meetingTags || [],
					},
				},
			};

			return accountOperations.addAccountMeetingNote(request.account, meetingRequest);
		},
	});
}
